import { useCallback, useMemo, useState } from 'react';

import { getPlaneChangeEvent } from '../Insurance.helpers';

export const useSearcher = ({ data, sensitive = false }) => {
  const [search, setSearch] = useState('');

  const list = useMemo(() => {
    if (!search) {
      return data;
    }

    const sensitiveSearch = sensitive ? search : search.toLowerCase();

    return data.reduce((acc, item) => {
      const { title } = item;
      const sensitiveTitle = sensitive ? title : title.toLowerCase();

      if (sensitiveTitle.includes(sensitiveSearch)) {
        acc.push(item);
      }

      return acc;
    }, []);
  }, [search, sensitive, data]);

  const onSearch = useCallback((event) => {
    const search = getPlaneChangeEvent(event);

    setSearch(search);
  }, []);

  return { list, onSearch };
};
